import React from "react";
import { Modal, Button, Spinner } from "react-bootstrap";
import "./paymentConnection.css";

const RemovePaymentSetupModal = ({ show, onHide, onConfirm, isLoading }) => (
  <Modal show={show} onHide={onHide} centered className="pc-modal">
    <Modal.Header closeButton>
      <Modal.Title>Remove Payment Setup?</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <p className="mb-0">
        This will permanently remove your payment setup and delete your payment account.
        This cannot be undone.
      </p>
    </Modal.Body>
    <Modal.Footer>
      <Button variant="outline-secondary" onClick={onHide} disabled={isLoading}>
        Cancel
      </Button>
      <Button variant="danger" onClick={onConfirm} disabled={isLoading}>
        {isLoading ? (
          <>
            <Spinner
              as="span"
              animation="border"
              size="sm"
              role="status"
              aria-hidden="true"
              className="me-2"
            />
            Removing...
          </>
        ) : (
          "Remove Payment Setup"
        )}
      </Button>
    </Modal.Footer>
  </Modal>
);

export default RemovePaymentSetupModal;
